import { render, staticRenderFns } from "./SVGDropdownSwitchArrowDown.vue?vue&type=template&id=faa12582&scoped=true&"
import script from "./SVGDropdownSwitchArrowDown.vue?vue&type=script&lang=js&"
export * from "./SVGDropdownSwitchArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa12582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faa12582')) {
      api.createRecord('faa12582', component.options)
    } else {
      api.reload('faa12582', component.options)
    }
    module.hot.accept("./SVGDropdownSwitchArrowDown.vue?vue&type=template&id=faa12582&scoped=true&", function () {
      api.rerender('faa12582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGDropdownSwitchArrowDown.vue"
export default component.exports